module.exports = __webpack_public_path__ + "static/media/Safekey.a1124edc.svg";